export enum VoucherStatusEnum {
  OnlyNotArchived = 0,
  Archived = 1,
  Both = 2,
}
